import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

import { StyledCustomTable } from '@/ui/components/CustomTable/CustomTable.styles'
import { drawerScrollFade } from '@/ui/drawer/common/drawerTable.styles'

export const TechnologiesTableWrapper = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
`

export const EmptyCard = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    padding: 20px 24px;
    border: 1px solid ${({ theme }) => theme.colors.semantic.tableBorder};
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.semantic.drawerBackground};
    color: ${({ theme }) => theme.colors.greys[500]};
`

export const TechnologiesTable = styled(StyledCustomTable)<{ theme?: TTheme }>`
    width: 100%;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.semantic.tableBorder};
    overflow: hidden;

    table {
        th:first-of-type {
            border-top-left-radius: 12px;
        }

        th:last-of-type {
            border-top-right-radius: 12px;
        }

        th {
            height: 44px;
            padding-top: 6px;
            padding-bottom: 6px;
        }

        td {
            padding-top: 18px;
            padding-bottom: 18px;
            vertical-align: middle;
            color: ${({ theme }) => theme.colors.greys[800]};
        }

        td:first-of-type {
            padding-left: 20px;
        }

        td:last-of-type {
            padding-right: 20px;
        }
    }

    ${drawerScrollFade}
`

export const Cell = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isClickable',
})<{ isClickable?: boolean }>`
    display: flex;
    align-items: center;
    cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
`

export const ChevronCell = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isClickable',
})<{ theme?: TTheme; isClickable?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: ${({ theme }) => theme.colors.primary[900]};
    cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};

    svg {
        width: 8px;
        height: 12px;
    }
`
